import React, { Component } from "react";
import { animateScroll as scroll } from "react-scroll";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  handleScroll() {
    if (this.mount) {
      this.setState({ scroll: window.scrollY });
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  componentDidMount() {
    this.mount = true;
    const el = document.querySelector("nav");
    this.setState({ top: el.offsetTop, height: el.offsetHeight });
    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    this.state.scroll > this.state.top
      ? document.getElementById("scroll-top").classList.add("show")
      : document.getElementById("scroll-top").classList.remove("show");
  }

  componentWillUnmount() {
    this.mount = false;
  }

  render() {
    return (
      <div>
        {/*====================  footer area ====================*/}
        <div className="footer-area dark-bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer-content-wrapper section-space--inner--100">
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-12">
                      {/* footer intro wrapper */}
                      <div className="footer-intro-wrapper">
                        <div className="footer-logo">
                          <a href={`${process.env.PUBLIC_URL}/`}>
                            <img
                              src="assets/img/logo/logo-light.png"
                              className="img-fluid"
                              alt=""
                            />
                          </a>
                        </div>
                        <div className="footer-desc">
                          <b>Shakuntla Learn and Fly Foundation</b> supports children with autism,
                          ADHD, cerebral palsy, and developmental challenges through
                          special education, therapy, and inclusive learning programs.
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-2 offset-xl-1 col-lg-3 col-md-4">
                      {/* footer widget */}
                      <div className="footer-widget">
                        <h4 className="footer-widget__title">QUICK LINKS</h4>
                        <ul className="footer-widget__navigation">
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/`}>Home</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/about-us`}>About</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/services`}>Services</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/contact-us`}>Contact</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-2 offset-xl-1 col-lg-3 col-md-4">
                      <div className="footer-widget">
                        <h4 className="footer-widget__title">OUR SERVICES</h4>
                        <ul className="footer-widget__navigation">
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/early-intervention`}>Early Intervention & Child Development</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/play-language-therapy`}>Play & Language Therapy</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/holistic-child-development`}>⁠Holistic Child Development</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/speech-therapy`}>⁠Speech Therapy</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/special-education`}>⁠Special Education</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/learning-support`}>⁠Learning Support</a>
                          </li>
                          <li>
                            <a href={`${process.env.PUBLIC_URL}/occupational-therapy`}>⁠Occupational Therapy</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-2 offset-xl-1 col-lg-3 col-md-4">
                      {/* footer widget */}
                      <div className="footer-widget mb-0">
                        <h4 className="footer-widget__title">CONTACT US</h4>
                        <div className="footer-widget__content">
                          <p className="address">
                            Plot No. 16, Khasra No. 108,
                            Rajendra Park, Block-B,
                            Gurugram, Haryana – 122001, India
                          </p>
                          <div className="footer-contact-info">
                            <a href="tel:+919643532525" className="contact-item">
                              <i className="zmdi zmdi-phone"></i>
                              <span>+91 96435 32525</span>
                            </a>

                            <a
                              href="mailto:info@shakuntlafoundation.org"
                              className="contact-item"
                            >
                              <i className="zmdi zmdi-email"></i>
                              <span>info@shakuntlafoundation.org</span>
                            </a>
                          </div>  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-copyright-wrapper">
            <div className="footer-copyright text-center">
              <p className="copyright-text">
                Copyrights &copy; 2026 Shakuntla Learn and Fly Foundation.<i className="fa fa-heart"></i> All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
        {/*====================  End of footer area  ====================*/}
        {/*====================  scroll top ====================*/}
        <button
          className="scroll-top"
          id="scroll-top"
          onClick={this.scrollToTop}
        >
          <i className="ion-android-arrow-up" />
        </button>
        {/*====================  End of scroll top  ====================*/}
      </div>
    );
  }
}

export default Footer;
